import { useState, FC, useEffect } from 'react';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import AccordionItem from './AccordionItem';
import {
  AccordionHeaderContent,
  AccordionItemContentType
} from '../../api/types';

interface Props {
  accordionList: {
    body: AccordionItemContentType[];
    header: AccordionHeaderContent;
    defaultActive?: boolean;
  }[];
  renderItem: (content: AccordionItemContentType[]) => JSX.Element;
  isClosedState?: boolean;
  classNameButton?: string;
  classNameItem?: string;
  gtagPrefix?: GTAGPrefix;
  onToggleHandler?: (title: string) => void;
  renderHeader: (
    content: AccordionHeaderContent,
    productsList: AccordionItemContentType[],
    active: boolean
  ) => JSX.Element;
}

const Accordion: FC<Props> = ({
  accordionList,
  isClosedState,
  renderItem,
  renderHeader,
  classNameItem,
  classNameButton,
  gtagPrefix,
  onToggleHandler
}) => {
  const { trackGtagEvent } = useGTAG();

  const [clicked, setClicked] = useState(null);
  const [isDefaultState, setIsDefaultState] = useState(true);

  const handleToggle = (index) => {
    setIsDefaultState(false);
    if (clicked === index) {
      setClicked(null);
    } else {
      setClicked(index);
    }
  };

  useEffect(() => {
    if (isClosedState) setClicked(null);
  }, [isClosedState]);

  return (
    <ul className="w-full">
      {accordionList.map((item, index) => (
        <AccordionItem
          key={index}
          info={item}
          onToggle={() => {
            handleToggle(index);
            trackGtagEvent(
              `${gtagPrefix}_manual_question`,
              item.header.title,
              'title'
            );
            if (onToggleHandler) {
              onToggleHandler(item.header.title);
            }
          }}
          active={(isDefaultState && item.defaultActive) || clicked === index}
          renderItem={renderItem}
          isClosedState={isClosedState}
          classNameItem={classNameItem}
          classNameButton={classNameButton}
          renderHeader={renderHeader}
        />
      ))}
    </ul>
  );
};

export default Accordion;
